import React from 'react';
import { Button, Col, Row } from 'antd';
import { LeftOutlined, RightOutlined, DoubleLeftOutlined, DoubleRightOutlined, VerticalRightOutlined, VerticalLeftOutlined } from '@ant-design/icons';
import RackTemplate from '../../../../../../models/RackTemplate';

interface NavigationArrowsProps {
  onNavigate: (direction: 'left' | 'right' | 'doubleLeft' | 'doubleRight' | 'topLeft' | 'topRight') => void;
  corridorName: string;
  position: { row: number, col: number };
  racktemplate: RackTemplate;
  hideArrows?: { left?: boolean; right?: boolean }; 
}

const NavigationArrows: React.FC<NavigationArrowsProps> = ({ onNavigate, hideArrows = {} }) => {
  return (
    <Row
    style={{ width: '100%', height: '100%' }}
    gutter={[8, 8]}
    align={"middle"}
    justify={'center'}
  >
    {!hideArrows.left && (
      <Col xs={24} sm={8}>
        <Row gutter={[8, 8]} align="middle" justify="center">
          <Col>
            <Button icon={<LeftOutlined />} onClick={() => onNavigate('left')} />
          </Col>
          <Col>
            <Button icon={<DoubleLeftOutlined />} onClick={() => onNavigate('doubleLeft')} />
          </Col>
          <Col>
            <Button type="primary" icon={<VerticalRightOutlined />} onClick={() => onNavigate('topLeft')} />
          </Col>
        </Row>
      </Col>
    )}
    {!hideArrows.right && (
      <Col xs={24} sm={8}>
        <Row gutter={[8, 8]} align="middle" justify="center">
          <Col>
            <Button icon={<RightOutlined />} onClick={() => onNavigate('right')} />
          </Col>
          <Col>
            <Button icon={<DoubleRightOutlined />} onClick={() => onNavigate('doubleRight')} />
          </Col>
          <Col>
            <Button type="primary" icon={<VerticalLeftOutlined />} onClick={() => onNavigate('topRight')} />
          </Col>
        </Row>
      </Col>
    )}
  </Row>
  );
};

export default NavigationArrows;